import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "confirm-icon" }
const _hoisted_3 = { class: "confirm-params" }
const _hoisted_4 = { class: "param" }
const _hoisted_5 = {
  key: 0,
  class: "ym-code"
}
const _hoisted_6 = { class: "param" }
const _hoisted_7 = { class: "confirm-desc" }
const _hoisted_8 = {
  key: 0,
  class: "status-message requesting"
}

import { ref, computed, watch, inject, type Ref } from 'vue';
import { useStore } from 'vuex';
import api from '@/services/api';
import { formatApiErrorMessage } from '@/utils/formatUserFacingError';


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsRequestModal',
  props: {
    modelValue: { type: Boolean },
    defaultYearMonth: {},
    memberCode: {},
    bizGubun: {}
  },
  emits: ["update:modelValue", "requested"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const isAdmin = computed(
  () => Number(store.getters.actualRoleLevel ?? store.getters.roleLevel ?? 0) >= 60
);

// MemberDetailLayout에서 provide한 값들
const injectedMemberData = inject<Ref<any>>('memberData', ref(null));
const injectedBizGubun = inject<Ref<string>>('selectedBizGubun', ref(''));

// props > inject > store 순으로 fallback
const memberCode = computed(() => 
  props.memberCode || injectedMemberData.value?.m_code || store.state.user?.m_code
);
const bizGubun = computed(() => 
  props.bizGubun || injectedBizGubun.value || store.state.user?.m_biz_gubun || ''
);

const dialog = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});

const selectedYearMonth = ref('');
const isRequesting = ref(false);
const requestStatus = ref<'success' | 'error' | ''>('');
const statusMessage = ref('');

const statusIcon = computed(() => {
  switch (requestStatus.value) {
    case 'success': return 'mdi-check-circle';
    case 'error': return 'mdi-alert-circle';
    default: return '';
  }
});

const displayYearMonth = computed(() => {
  if (!selectedYearMonth.value || selectedYearMonth.value.length !== 6) return '-';
  const y = selectedYearMonth.value.substring(0, 4);
  const m = parseInt(selectedYearMonth.value.substring(4, 6));
  return `${y}년 ${m}월`;
});

watch(() => props.modelValue, (val) => {
  if (val) {
    requestStatus.value = '';
    statusMessage.value = '';
    if (props.defaultYearMonth) {
      selectedYearMonth.value = props.defaultYearMonth;
    } else {
      const now = new Date();
      selectedYearMonth.value = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
    }
  }
});

const closeModal = () => {
  dialog.value = false;
};

const submitRequest = async () => {
  if (!memberCode.value || !bizGubun.value) {
    requestStatus.value = 'error';
    statusMessage.value = isAdmin.value
      ? '기관 정보(m_code)를 불러올 수 없습니다.'
      : '기관 정보를 불러올 수 없습니다.';
    return;
  }

  isRequesting.value = true;
  requestStatus.value = '';

  try {
    await api.post('/macro/request', {
      m_code: memberCode.value,
      cmq_type: 'caion_ltcs_schedule_plan',
      params: {
        m_code: memberCode.value,
        yearMonth: selectedYearMonth.value,
        bizGubun: bizGubun.value
      }
    });
    requestStatus.value = 'success';
    statusMessage.value = '요청 완료!';
    isRequesting.value = false;
    
    setTimeout(() => {
      closeModal();
      if (confirm('일정계획 요청이 등록되었습니다.\n데이터 반영까지 약간의 시간이 소요됩니다.\n\n페이지를 새로고침하시겠습니까?')) {
        window.location.reload();
      }
      emit('requested');
    }, 500);
    return;
  } catch (error: any) {
    requestStatus.value = 'error';
    statusMessage.value = formatApiErrorMessage(error, {
      verbose: isAdmin.value,
      fallback: '요청에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    });
  } finally {
    isRequesting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    "max-width": "400",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "ltcs-request-modal" }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "ltcs-request-modal__close",
            "aria-label": "닫기",
            disabled: isRequesting.value,
            onClick: closeModal
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_1),
          _createVNode(_component_v_card_text, { class: "modal-body" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#1e3a5f"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("mdi-cloud-download", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "confirm-title" }, "일정계획 데이터 요청", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(displayYearMonth.value), 1),
                (selectedYearMonth.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(selectedYearMonth.value), 1))
                  : _createCommentVNode("", true),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "divider" }, "·", -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(bizGubun.value), 1)
              ]),
              _createElementVNode("div", _hoisted_7, " 위 연월(" + _toDisplayString(selectedYearMonth.value || '-') + ")·사업구분으로 롱텀케어에서 데이터를 가져옵니다 ", 1),
              (isRequesting.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      size: "16",
                      width: "2"
                    }),
                    _cache[4] || (_cache[4] = _createElementVNode("span", null, "요청 중...", -1))
                  ]))
                : (requestStatus.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["status-message", requestStatus.value])
                    }, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(statusIcon.value), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(statusMessage.value), 1)
                    ], 2))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "modal-actions" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                class: "btn-cancel",
                onClick: closeModal,
                disabled: isRequesting.value
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" 취소 ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                variant: "flat",
                class: "btn-register",
                loading: isRequesting.value,
                onClick: submitRequest
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" 요청 ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})